module.exports = __webpack_public_path__ + "static/media/shoot.efe5e7b8.mp3";